import { useState,useEffect } from "react";
import { LogIn } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
  import { supabase } from "../functions/supabaseClient";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();


  useEffect(() => {
   

  }, []);


   const checkOAuthSession = async () => {
      const { data: { session } } = await supabase.auth.getSession();

      if (session) {

        console.log(session.access_token)
        // خزّن التوكن
        localStorage.setItem("token", session.access_token);
        localStorage.setItem("refresh_token", session.refresh_token);

        // توجيه المستخدم للصفحة الرئيسية بعد تسجيل الدخول
        navigate("/dashboard");
      }
    };
const handleGoogleLogin = async () => {
  const { error } = await supabase.auth.signInWithOAuth({
    provider: "google",
    options: {
      redirectTo: "https://zaichat.net/auth/callback"
    },
  });

  if (error) {
    console.error("Google login error:", error.message);
    alert("Failed to login with Google.");
  }
};
//    useEffect(() => {
//     const getSession = async () => {
//       const { data: { session } } = await supabase.auth.getSession();
//       if (session) {
//         // خزّن التوكن في localStorage
//         localStorage.setItem("token", session.access_token);
//         localStorage.setItem("refresh_token", session.refresh_token);

//         // توجيه المستخدم للصفحة الرئيسية
//         navigate("/dashboard");
//       } else {
//         // إذا ما في جلسة، خليه على صفحة login
//         navigate("/login");
//       }
//     };

// getSession()
//   },[])


  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await fetch("https://zaichat.net/api/login", {
        method: "POST",
        body: JSON.stringify({
          email: email,
          password: password,
        }),
        headers: { "Content-Type": "application/json" },
      });

      if (!response.ok) {
        throw new Error("Login failed. Please check your credentials.");
      }

      const data = await response.json();
      console.log("Login response:", data);

      // Check if session exists
      if (!data.session || !data.session.access_token) {
        throw new Error("Invalid response from server");
      }

      localStorage.setItem("token", data.session.access_token);
      localStorage.setItem("refresh_token", data.session.refresh_token);

      // Dispatch storage event for other components
      window.dispatchEvent(new Event("storage"));

      navigate("/dashboard");
    } catch (err) {
      console.error("Login error:", err);
      setError(err.message || "Failed to connect to server. Please try again.");
    } finally {
      setLoading(false);
    }
  };




  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-cream to-white px-4">
      <div className="bg-white rounded-3xl shadow-2xl p-10 w-full max-w-md text-center border border-primary/10">
        {/* Logo + Header */}
        <div className="mb-8">
          <img
            src="/zuccesslogo2.png"
            alt="Zuccess Logo"
            className="w-24 mx-auto drop-shadow-md"
          />
          <h1 className="text-3xl font-extrabold text-primary mt-4 tracking-tight">
            Welcome Back
          </h1>
          <p className="text-dark/70 text-sm mt-1">
            Log in to your{" "}
            <span className="text-accent font-semibold">Zuccess</span> Dashboard
          </p>
        </div>

        {/* Error Message */}
        {error && (
          <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-600 text-sm">
            {error}
          </div>
        )}

        {/* Form */}
        <form onSubmit={handleLogin} className="space-y-5 text-left">
          <div>
            <label className="block text-sm font-medium text-primary mb-1">
              Email Address
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-primary/20 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-accent"
              placeholder="you@example.com"
              required
              disabled={loading}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-primary mb-1">
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-primary/20 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-accent"
              placeholder="••••••••"
              required
              disabled={loading}
            />
          </div>

          {/* Login Button */}
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-accent text-white py-3 rounded-lg font-semibold hover:bg-accent/90 transition flex items-center justify-center gap-2 shadow-md disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? (
              <>Loading...</>
            ) : (
              <>
                <LogIn size={18} /> Log In
              </>
            )}
          </button>
        </form>

        <button
          onClick={handleGoogleLogin}
          className="w-full bg-gray-500 text-white py-3 rounded-lg font-semibold hover:bg-red-600 mt-3 flex items-center justify-center gap-2"
        >
          <img src="./google.png" alt="google-icon" className="w-5 h-5" />
          Log in with Google
        </button>

        {/* Footer Links */}
        <div className="mt-6">
          <p className="text-sm text-dark/70">
            Don't have an account?{" "}
            <Link
              to="/register"
              className="text-accent font-semibold hover:underline hover:text-primary"
            >
              Register
            </Link>
          </p>
        </div>

        {/* Footer Note */}
        <p className="text-[11px] text-dark/50 mt-8">
          © {new Date().getFullYear()} Zuccess. All rights reserved.
        </p>
      </div>
    </div>
  );
}